module.exports = __webpack_public_path__ + "static/nginr-53d45676c1e3dfe69345ecc91cd5b923.png";